import TimeUtils from "./TimeUtils";
import DataObj from "../class/DataObj";
import ZeroTimeUtils from "./ZeroTimeUtils";

/**
 * 拖拉區域 相關功能
 * */
export default class DragHandleUtils {
    static setDragHandleDragValue(currentTime) {

        // //實際要移動秒數
        // let moveseconds = currentTime
        //
        // let frameWidth = 2.76; //frame的寬度
        // let videoFps = TimeUtils.getFPS();
        //
        // //位移
        // const handleDragValue = parseFloat(currentTime)*-1*parseFloat(videoFps)*parseFloat(frameWidth);
        // var foo = document.getElementById('waveform-frame');
        // foo.style.left = `${handleDragValue}px`;

        //實際要移動秒數
        let moveseconds = currentTime;

        //位移
        const handleDragValue = moveseconds * 40 * -1;
        var foo = document.getElementById('waveform-frame');
        foo.style.left = `${handleDragValue}px`;
    }



    static handleStop(_waveformview) {

        //更新影片位置
        let newSecond = _waveformview.handleDragValue * -1 / 40;
        _waveformview.player.seek(newSecond);


        //更新拖拉位置
        // console.log(`newSecond ${newSecond}`);
        DragHandleUtils.setDragHandleDragValue(newSecond);

        //拖拉到的位置
        let currentDataIndex = TimeUtils.secondsConvertToRowIndew(newSecond, _waveformview.videoFps, _waveformview.DataObjArray.getContent());
        // let curentFrame = TimeUtils.convertSecondToFrame(newSecond,this.props.videoFps);
        _waveformview.Last_currentDataIndex = currentDataIndex;
        //利用時間 來取出對應到的index 然後快速更新字幕
        _waveformview.updateSubTitle_by_row_frame(currentDataIndex);

        //表格黃標要去追選中的index
        _waveformview.hotTableComponent.current.hotInstance.loadData(_waveformview.DataObjArray.getContent());
        _waveformview.hotTableComponent.current.hotInstance.scrollViewportTo(currentDataIndex, 0);
        _waveformview.hotTableComponent.current.hotInstance.selectCell(currentDataIndex, 0);
    }

    //灰匡 字幕格 點擊兩下
    static setDoubleClick(_waveformview, newIndex) {


        _waveformview.Last_currentDataIndex = newIndex;

        //更新表格
        _waveformview.saveData_update_EditTable_ITManPlayer_WaveGroup(_waveformview.DataObjArray.getContent());
        _waveformview.hotTableComponent.current.hotInstance.scrollViewportTo(newIndex, 0);
        _waveformview.hotTableComponent.current.hotInstance.selectCell(newIndex, 0);

        //網上傳
        _waveformview.moveCellSelect(newIndex);


        //移動
        _waveformview.setDragHandleDragValue_byIndex(newIndex);
    }


    /**
     * 灰框拖拉 往左
     * */
    static stopDrag_move(_waveformview) {
        ///isTimecodeLock設定的話就不能拖拉
        if (_waveformview.projectDetial.isTimecodeLock === 1 || parseInt(_waveformview.props.match.params.tType, 10) === 0) {
            return;
        }

        let frameWidth = 2.76; //frame的寬度
        let videoFps = TimeUtils.getFPS();

        //一秒frame數
        const oneSecondPX = 40;

        //取得拖拉資料
        _waveformview.popups_index = parseFloat(`${_waveformview.element.id}`.replace('popup_', ''));
        _waveformview.userWantLeft = parseFloat(`${_waveformview.element.style.left}`.replace('px', ''));
        let width = parseFloat(`${_waveformview.element.style.width}`.replace('px', ''));
        _waveformview.userWantRight = _waveformview.userWantLeft + width;


        //取得資料物件
        let newData = _waveformview.DataObjArray.getContent();
        let currentDataObj = new DataObj(newData[_waveformview.popups_index]);


        if (_waveformview.dragDirection === 'left') {
            //新的秒數
            const newStartSecond = (_waveformview.userWantLeft - _waveformview.frontDistance) / oneSecondPX;

            //調整開始時間
            currentDataObj.setInOut("In", ZeroTimeUtils.convertPlayerTimeToDataObjSeconds(newStartSecond));
            newData[_waveformview.popups_index] = currentDataObj;
            //更新表格
            _waveformview.DataObjArray.updateDataObj_by_index(_waveformview.popups_index, currentDataObj);
            _waveformview.updateInstanceTable_by_Row(_waveformview.popups_index);


            //檢察上一個的out時間有沒有重疊
            if (_waveformview.popups_index > 0) {

                let currentInFrame = TimeUtils.timeString_convertTo_frame(currentDataObj.In);

                const lastDataIndex = _waveformview.popups_index - 1;
                let lastDataObj = new DataObj(newData[lastDataIndex]);


                //上一個有結束時間才需要設定
                if (lastDataObj.Out !== '') {

                    let lastOutFrame = TimeUtils.timeString_convertTo_frame(lastDataObj.Out);

                    const distant = currentInFrame - lastOutFrame;

                    if (distant < _waveformview.props.context.findFrameSplitValue) {

                        let currentDataObj_In_Frame = TimeUtils.timeString_convertTo_frame(currentDataObj.In, videoFps);

                        // 設定上一個的尾端位置
                        // lastDataObj.setInOut("Out", TimeUtils.getTimeStringFrom_FrameCount(currentDataObj_In_Frame - this.props.context.findFrameSplitValue,this.props.videoFps));

                        lastDataObj.setInOut('Out', TimeUtils.useStringCountFrame(currentDataObj.In, _waveformview.videoFps, parseFloat(_waveformview.findFrameSplitValue) * -1))

                        newData[lastDataIndex] = lastDataObj;
                        _waveformview.DataObjArray.updateDataObj_by_index(lastDataIndex, lastDataObj);

                        //更新拖拉介面:調整上一個的寬度
                        let lastElement = _waveformview.popups[lastDataIndex];
                        const lastWidth = lastDataObj.getDragEleWidth();
                        lastElement.style.width = lastWidth + "px";

                        //更新表格
                        _waveformview.updateInstanceTable_by_Row(lastDataIndex);
                    }
                }
            }
        }
        else {
            //調整結束時間　
            const newEndSecond = (_waveformview.userWantRight - _waveformview.frontDistance) / oneSecondPX;//新的結束秒數
            currentDataObj.setInOut("Out", ZeroTimeUtils.convertPlayerTimeToDataObjSeconds(newEndSecond));

            //更新表格
            _waveformview.DataObjArray.updateDataObj_by_index(_waveformview.popups_index, currentDataObj);
            _waveformview.updateInstanceTable_by_Row(_waveformview.popups_index);

            //this.props.setTableDataObj(dataObj,dataIndex);


            //檢察下一組物件時間有沒有重疊
            if (_waveformview.popups_index !== (newData.length - 1)) {

                //下一組物件　檢察
                let nextIndex = _waveformview.popups_index + 1;
                let nextDataObj = new DataObj(newData[nextIndex]);

                //下一個有開始時間才需要設定
                if (nextDataObj.In !== '') {

                    let currentOutFrame = TimeUtils.timeString_convertTo_frame(currentDataObj.Out);
                    let nextInFrame = TimeUtils.timeString_convertTo_frame(nextDataObj.In);

                    const distant = nextInFrame - currentOutFrame;
                    if (distant < _waveformview.props.context.findFrameSplitValue) {

                        // nextDataObj.setInOut('In',TimeUtils.getTimeStringFrom_FrameCount((currentOutFrame + this.props.context.findFrameSplitValue),videoFps));

                        nextDataObj.setInOut('In', TimeUtils.useStringCountFrame(
                            currentDataObj.Out,
                            _waveformview.props.videoFps,
                            parseFloat(_waveformview.findFrameSplitValue) * 1))


                        newData[nextIndex] = nextDataObj;
                        _waveformview.DataObjArray.updateDataObj_by_index(nextIndex, nextDataObj);


                        //更新拖拉介面:調整上一個的寬度
                        let nextElement = _waveformview.popups[nextIndex];
                        const nextElementLeft = nextDataObj.getDragEleLeft();
                        const nextElementWidth = nextDataObj.getDragEleWidth();
                        nextElement.style.left = nextElementLeft + "px";
                        nextElement.style.width = nextElementWidth + "px";

                        //更新表格
                        _waveformview.updateInstanceTable_by_Row(nextIndex);
                    }
                }
            }
        }

        //更新所有
        newData[_waveformview.popups_index] = currentDataObj;

        _waveformview.DataObjArray.updateDataObj_by_index(_waveformview.popups_index, currentDataObj);

        _waveformview.saveData_update_EditTable_ITManPlayer_WaveGroup(_waveformview.DataObjArray.getContent());

    }




}



// WEBPACK FOOTER //
// ./src/helper/DragHandleUtils.js